<template>
  <div class="app-wrapper">
    <!-- <nuttrema-loader :showImage="false" loadingText="label.application_loading" theme="grey-logo"></nuttrema-loader> -->
    <template v-if="isReady">
      <router-view></router-view>
    </template>
    <template v-else>
      <nuttrema-loader :showImage="false" loadingText="label.application_loading" theme="grey-logo"></nuttrema-loader>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSubdomain } from 'utils';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import RedirectLogged from 'components/mixins/redirect-logged';

export default {
  name: 'dc-nuttrema-web',
  mixins: [
    RedirectLogged,
  ],
  components: {
    NuttremaLoader,
  },
  methods: {
    fetch() {
      const subdomain = getSubdomain();
      console.log('subdomain', subdomain);
      this.$store.dispatch('GetInstanceInfo', { subdomain });

      this.$store.dispatch('GetSettingsLanguages', { app_support: true });
      this.$store.dispatch('GetInstanceSubscribedPlanSummarized');
    },
  },
  computed: {
    ...mapGetters([
      'InstanceInfo',
      'SettingsLanguages',
      'InstanceSubscribedPlanSummarized',
    ]),
    isReady() {
      return this.$auth.ready() && !this.SettingsLanguages.fetching && !this.InstanceInfo.fetching && !this.InstanceSubscribedPlanSummarized.fetching;
    },
  },
  created() {
    console.log('dc-nuttrema-web created', this.$auth, this.$route, this.$router);
    this.redirectAuthorisationRequired();
    this.fetch();
  },
};
</script>

<style lang="scss">
@import '~vue-resize/dist/vue-resize.css';
@import '~element-ui/lib/theme-chalk/index.css';
@import "~styles/app.scss";
</style>



// WEBPACK FOOTER //
// src/DcNuttremaWeb.vue